
export const environment = {
    production: false,
    API_BASE: 'https://api.dev.indo-erp.maximimpressions.com',
    // MAS_PORTAL: 'https://api.mas-portal.maximimpressions.com',
    MAS_PORTAL: 'http://localhost:9003/MaximImpressionApiClient/v2/purchaseOrder/download/po',


    cache: {
      maxSize: 5000,

      /**
       * Max Age
       *
       * @type string
       * @default 1h
       * @description TTL of the cache. Use the below format
       * 1d2h3m4s5u
       * - d - Days
       * - h - hours
       * - m - minutes
       * - s - seconds
       * - u - milliseconds
       */
      maxAge: '1d'
    },
  }

